import React from 'react';

import styles from './ModalDialog.module.css';

const ModalDialog = ({
  title,
  message,
  children,
  confirmLabel,
  cancelLabel,
  onConfirm,
  onClose,
  hideConfirm = false,
}) => (
  <div className={styles.overlay} role="dialog" aria-modal="true">
    <div className={styles.dialog}>
      {title && <h3 className={styles.title}>{title}</h3>}
      {message && <div className={styles.body}>{message}</div>}
      {children}
      <div className={styles.actions}>
        <button className={styles.secondaryButton} type="button" onClick={onClose}>
          {cancelLabel}
        </button>
        {!hideConfirm && (
          <button className={styles.primaryButton} type="button" onClick={onConfirm}>
            {confirmLabel}
          </button>
        )}
      </div>
    </div>
  </div>
);

export default ModalDialog;
